module.exports = __webpack_public_path__ + "static/media/loanIco_Selected.5d30529d.svg";